import { z } from "zod";

export const OpenFoodFactsSearchItemSchema = z.object({
    code: z.string(),
    name: z.string(),
    brand: z.string().nullable(),
    imageUrl: z.string().nullable(),
    quantityLabel: z.string().nullable(),
});

export const OpenFoodFactsSearchResultSchema = z.object({
    items: OpenFoodFactsSearchItemSchema.array(),
    page: z.number(),
    pageSize: z.number(),
    total: z.number(),
});

export const OpenFoodFactsResolvedReferenceSchema = z.object({
    compositeId: z.string(),
    id: z.number(),
    source: z.literal("sure"),
    name: z.string(),
    defaultOrigin: z.string().nullable(),
    fresh: z.boolean().nullable(),
});

export const OpenFoodFactsResolvedIngredientSchema = z.object({
    ingredientReference: OpenFoodFactsResolvedReferenceSchema.nullable(),
    offName: z.string(),
    ciqualCode: z.string().nullable(),
    offIngredientId: z.string().nullable(),
    percent: z.number().nullable(),
    status: z.enum(["matched", "unmatched"]),
});

export const OpenFoodFactsResolvedProductSchema = z.object({
    code: z.string(),
    title: z.string(),
    netWeight: z.number().nullable(),
    imageUrl: z.string().nullable(),
    productReference: OpenFoodFactsResolvedReferenceSchema.nullable(),
    organic: z.boolean().nullable(),
    ingredients: OpenFoodFactsResolvedIngredientSchema.array(),
    totalIngredientCount: z.number(),
    unmatchedIngredientCount: z.number(),
});

export type OpenFoodFactsSearchItem = z.infer<typeof OpenFoodFactsSearchItemSchema>;
export type OpenFoodFactsSearchResult = z.infer<typeof OpenFoodFactsSearchResultSchema>;
export type OpenFoodFactsResolvedProduct = z.infer<typeof OpenFoodFactsResolvedProductSchema>;
